import { periodSliceActions } from "./periodSlice"

export const periodActions = {
    ...periodSliceActions
}
